import { useState, useRef, useEffect } from 'react';

const faqs = [
  {
    q: '¿Cómo pido un domicilio?',
    a: 'Nos llamas o escribes por WhatsApp al +57 320 678 9030. Nos cuentas qué necesitas, confirmamos disponibilidad y te confirmamos tiempos de entrega. Pagas al recibir tu pedido.',
  },
  {
    q: '¿Qué zonas cubren con domicilios?',
    a: 'Llevamos domicilios en Pereira centro, Cuba y Boston, Pinares, Álamos, Dosquebradas centro y Frailes. Si no estás seguro de tu zona, llámanos y te confirmamos.',
  },
  {
    q: '¿Necesito presentar fórmula médica?',
    a: 'Sí. Para medicamentos de venta bajo prescripción médica es obligatorio presentar la fórmula, según las normas del INVIMA (Instituto Nacional de Vigilancia de Medicamentos y Alimentos). Sin fórmula no podemos despachar estos productos.',
  },
  {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Aceptamos efectivo al momento de la entrega, transferencia bancaria y Nequi. Te confirmamos los datos de pago cuando confirmamos tu pedido.',
  },
  {
    q: '¿En cuánto tiempo llega mi domicilio?',
    a: 'Depende de tu zona y la disponibilidad de los productos. En general, los domicilios en Pereira y Dosquebradas se entregan el mismo día. Te damos un tiempo estimado exacto cuando confirmamos tu pedido.',
  },
  {
    q: '¿Puedo pasar al punto físico?',
    a: 'Claro que sí. Nuestro punto físico está en Calle 24 # 19-18 Local 101 (Barrio Providencia), Pereira, Risaralda. Atendemos de lunes a viernes de 8am a 12pm y de 2pm a 5pm, y los sábados de 9am a 1pm.',
  },
  {
    q: '¿Qué hago si un producto llega en mal estado?',
    a: 'Cuéntanos de inmediato. Si un producto llega en mal estado o no cumple con lo acordado, lo revisamos y te damos una solución: cambio o devolución según corresponda.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="faq" ref={ref} className="bg-white py-[72px] md:py-24">
      <div className="mx-auto max-w-[800px] px-6 md:px-12">
        <h2 className="mb-12 text-center font-serif text-[28px] font-bold text-md-ink md:mb-14 md:text-[42px]">
          Preguntas frecuentes
        </h2>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`rounded-xl border border-transparent bg-md-bg transition-all duration-200 hover:border-md-sky ${
                  visible ? 'animate-fade-in-up' : 'opacity-0'
                }`}
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between px-6 py-5 text-left md:px-7 md:py-6"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <span className="pr-4 text-[15px] font-semibold text-md-ink md:text-[17px]">
                    {faq.q}
                  </span>
                  <span
                    className={`flex h-6 w-6 flex-shrink-0 items-center justify-center text-[20px] text-md-teal transition-transform duration-200 md:h-6 md:w-6 ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  >
                    <i className={isOpen ? 'ri-close-line' : 'ri-add-line'} />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-out ${
                    isOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-5 text-[15px] leading-[1.7] text-md-slate md:px-7 md:pb-6 md:text-[16px]">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}